/**
 * The loan pipeline's (All Loans) State and Loan Amount columns, and the
 * width its columns add up to.
 */

/**
 * The loan amount (merged.loan_selections.loan_size) as a number, or null
 * when the loan has none. The list sends it as text. 0 is what a loan holds
 * before anyone has entered an amount, so it counts as none.
 */
export function loanAmountValue(value) {
    const amount = Number(String(value == null ? "" : value).replace(/[$,\s]/g, ""))
    return Number.isFinite(amount) && amount > 0 ? amount : null
}

/** "$185,000", or "" when the loan has no amount. */
export function formatLoanAmount(value) {
    const amount = loanAmountValue(value)
    return amount === null ? "" : "$" + Math.round(amount).toLocaleString("en-US")
}

// antd negates a sorter's result for "descend", so a missing value has to
// flip its sign to stay at the bottom both ways.
function missingLast(ka, kb, sortOrder, compare) {
    if (ka === null && kb === null) return 0
    const last = sortOrder === "descend" ? -1 : 1
    if (ka === null) return last
    if (kb === null) return -last
    return compare(ka, kb)
}

/** An antd column sorter: smallest amount first, loans without one last whichever way the column sorts. */
export function compareLoanAmount(a, b, sortOrder) {
    return missingLast(loanAmountValue(a), loanAmountValue(b), sortOrder, (x, y) => x - y)
}

/** An antd column sorter: states A to Z, loans without one last whichever way the column sorts. */
export function compareState(a, b, sortOrder) {
    return missingLast(a || null, b || null, sortOrder, (x, y) => x.localeCompare(y))
}

/**
 * The checkbox column's width (the table's rowSelection.columnWidth): 25 px
 * left padding (Borrowers.css), the 16 px box, 8 px right padding. antd's
 * default 32 px lets the box run into the Loan Address column.
 */
export const SELECTION_COLUMN_WIDTH = 49

/**
 * What the columns' widths add up to with the checkbox column: the table's
 * scroll width on screens too narrow for it, so the columns keep their widths
 * whichever of them this user sees. On a phone, antd hides the columns marked
 * responsive: ["md"], so they don't count.
 */
export function columnsWidth(columns, { mobile = false } = {}) {
    return columns
        .filter((column) => !(mobile && column.responsive))
        .reduce((sum, column) => sum + (column.width || 0), SELECTION_COLUMN_WIDTH)
}
